module.exports = __webpack_public_path__ + "static/media/logo.9b03144f.svg";